<template>
  <div class="pe-page">
    <div class="pe-vista-bar">
      <div class="pe-field pe-field--date">
        <label>Periodo</label>
        <input v-model="periodoMes" type="month" @change="cargar">
      </div>
      <div class="pe-vista-meta">
        <strong>CEBADO POR SALA</strong>
        <span>{{ mesAnioLabel }}</span>
      </div>
      <div class="pe-header__actions">
        <button
          type="button"
          class="pe-icon-btn"
          title="Restablecer"
          :disabled="cargando || guardando"
          @click="restablecer"
        >
          <v-icon size="20" color="#334155">mdi-refresh</v-icon>
        </button>
        <button
          type="button"
          class="pe-btn pe-btn--primary"
          :disabled="guardando || cargando"
          @click="guardar"
        >
          <v-icon size="18" color="white">mdi-content-save-outline</v-icon>
          {{ guardando ? 'Guardando…' : 'Guardar Registro' }}
        </button>
      </div>
    </div>

    <div class="pe-legend kx-legend">
      <span><i class="pe-dot pe-dot--yellow" /> Subtotal semanal (lun–sáb) y total</span>
      <span><i class="pe-dot pe-dot--blue" /> Días lun–sáb según calendario del mes</span>
      <span v-if="edicionLibre"><i class="pe-dot pe-dot--gray" /> Puede editar días, nombres, y agregar/eliminar salas</span>
      <span v-else><i class="pe-dot pe-dot--gray" /> Hoy y día anterior; si es sábado, también el lunes siguiente</span>
    </div>

    <KardexGrid
      v-for="sec in secciones"
      :key="sec.tipo"
      :config="sec.config"
      :mes-label="mesAnioLabel"
      :anio="anio"
      :mes="mes"
      :valores="valores[sec.tipo]"
      :etiquetas="etiquetasDe(sec.tipo)"
      :estructura="estructuraDe(sec.tipo)"
      :edicion-libre="edicionLibre"
      embedded
      show-mes-row
      @celda="onCelda(sec.tipo, $event)"
      @etiqueta="onEtiqueta(sec.tipo, $event)"
      @agregar-sala="onAgregarSala(sec.tipo)"
      @eliminar-sala="onEliminarSala(sec.tipo, $event)"
      @agregar-item="onAgregarItem(sec.tipo, $event)"
      @eliminar-item="onEliminarItem(sec.tipo, $event)"
    />
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import KardexGrid from '../kardex/KardexGrid.vue'
import {
  configKardex,
  MESES_NOMBRE,
  buildDiasMes,
  buildDiasRegistro,
  blankEstructura,
  normalizarEstructura,
  aplicarEstructura,
  idsFilasConfig,
  nuevoIdCampo,
} from '../kardex/catalogos'
import { apiGetAutenticado, apiPostAutenticado } from '@/services/apiService/apiMethodService'

const TIPOS = ['cebado_sistemas', 'consumo_clna']

function blankEtiquetas() {
  return { items: {}, categorias: {}, salas: {} }
}

export default {
  name: 'PeCebadoPorSala',
  components: { KardexGrid },
  data() {
    return {
      periodoMes: '',
      valores: {},
      etiquetas: {},
      estructura: {},
      registroIds: {},
      cargando: false,
      guardando: false,
    }
  },
  computed: {
    edicionLibre() {
      return !!(this.$route.meta && this.$route.meta.edicionLibre)
    },
    secciones() {
      return TIPOS.map((tipo) => ({
        tipo,
        config: configKardex(tipo),
      })).filter(s => s.config)
    },
    anio() {
      if (!this.periodoMes) return new Date().getFullYear()
      return Number(this.periodoMes.split('-')[0])
    },
    mes() {
      if (!this.periodoMes) return new Date().getMonth() + 1
      return Number(this.periodoMes.split('-')[1])
    },
    mesAnioLabel() {
      return `${MESES_NOMBRE[this.mes] || ''} ${this.anio}`.trim()
    },
  },
  created() {
    const now = new Date()
    const m = String(now.getMonth() + 1).padStart(2, '0')
    this.periodoMes = `${now.getFullYear()}-${m}`
    this.initValores()
    this.cargar()
  },
  methods: {
    blankEtiquetas,
    etiquetasDe(tipo) {
      return this.etiquetas[tipo] || blankEtiquetas()
    },
    estructuraDe(tipo) {
      return this.estructura[tipo] || blankEstructura()
    },
    configVista(tipo) {
      return aplicarEstructura(configKardex(tipo), this.estructuraDe(tipo))
    },
    normalizarEtiquetas(raw) {
      const base = blankEtiquetas()
      if (!raw || typeof raw !== 'object') return base
      ;['items', 'categorias', 'salas'].forEach((k) => {
        if (raw[k] && typeof raw[k] === 'object') base[k] = { ...raw[k] }
      })
      return base
    },
    idsFilas(tipo) {
      return idsFilasConfig(this.configVista(tipo))
    },
    asegurarFilaValores(tipo, id) {
      if (!id) return
      if (!this.valores[tipo]) this.$set(this.valores, tipo, {})
      if (!this.valores[tipo][id]) this.$set(this.valores[tipo], id, {})
      const dias = buildDiasMes(this.anio, this.mes)
      dias.forEach((d) => {
        if (this.valores[tipo][id][String(d)] === undefined) {
          this.$set(this.valores[tipo][id], String(d), 0)
        }
      })
    },
    initValores() {
      const next = {}
      const nextEtq = {}
      const nextEst = {}
      const dias = buildDiasMes(this.anio, this.mes)
      TIPOS.forEach((tipo) => {
        next[tipo] = {}
        nextEtq[tipo] = blankEtiquetas()
        nextEst[tipo] = blankEstructura()
        idsFilasConfig(configKardex(tipo)).forEach((id) => {
          next[tipo][id] = {}
          dias.forEach((d) => {
            next[tipo][id][String(d)] = 0
          })
        })
      })
      this.valores = next
      this.etiquetas = nextEtq
      this.estructura = nextEst
      this.registroIds = {}
    },
    totalGeneral(tipo) {
      let sum = 0
      const dias = buildDiasRegistro(this.anio, this.mes)
      this.idsFilas(tipo).forEach((id) => {
        const fila = (this.valores[tipo] || {})[id] || {}
        dias.forEach((d) => {
          sum += Number(fila[String(d)] || 0)
        })
      })
      return sum
    },
    async cargarTipo(tipo) {
      const qs = [
        `tipo=${encodeURIComponent(tipo)}`,
        `anio=${this.anio}`,
        `mes=${this.mes}`,
        `sala=`,
      ].join('&')
      const res = await apiGetAutenticado(`/pe_kardex/buscar/?${qs}`)
      if (!this.valores[tipo]) this.$set(this.valores, tipo, {})
      if (!this.etiquetas[tipo]) this.$set(this.etiquetas, tipo, blankEtiquetas())
      if (!this.estructura[tipo]) this.$set(this.estructura, tipo, blankEstructura())

      if (res && res.existe) {
        this.$set(this.registroIds, tipo, res.id)
        const resp = res.responsables || {}
        this.$set(this.etiquetas, tipo, this.normalizarEtiquetas(resp.etiquetas))
        this.$set(this.estructura, tipo, normalizarEstructura(resp.estructura))
      } else {
        this.$set(this.registroIds, tipo, null)
        this.$set(this.etiquetas, tipo, blankEtiquetas())
        this.$set(this.estructura, tipo, blankEstructura())
      }

      const dias = buildDiasMes(this.anio, this.mes)
      const next = {}
      this.idsFilas(tipo).forEach((id) => {
        next[id] = {}
        dias.forEach((d) => {
          next[id][String(d)] = 0
        })
      })
      this.$set(this.valores, tipo, next)
      if (res && res.existe) {
        const vals = res.valores || {}
        Object.keys(vals).forEach((id) => {
          if (!this.valores[tipo][id]) this.$set(this.valores[tipo], id, {})
          const fila = vals[id] || {}
          Object.keys(fila).forEach((dia) => {
            this.$set(this.valores[tipo][id], String(dia), Number(fila[dia]) || 0)
          })
        })
      }
    },
    async cargar() {
      this.cargando = true
      try {
        await Promise.all(TIPOS.map(tipo => this.cargarTipo(tipo)))
      } catch (e) {
        console.error(e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar el registro.',
        })
      } finally {
        this.cargando = false
      }
    },
    onCelda(tipo, { itemId, dia, raw }) {
      if (!this.valores[tipo]) this.$set(this.valores, tipo, {})
      if (!this.valores[tipo][itemId]) this.$set(this.valores[tipo], itemId, {})
      const n = raw === '' ? 0 : Number(raw)
      this.$set(this.valores[tipo][itemId], String(dia), Number.isFinite(n) ? n : 0)
    },
    onEtiqueta(tipo, { grupo, id, nombre }) {
      if (!grupo || id == null) return
      if (!this.etiquetas[tipo]) this.$set(this.etiquetas, tipo, blankEtiquetas())
      if (!this.etiquetas[tipo][grupo]) this.$set(this.etiquetas[tipo], grupo, {})
      this.$set(this.etiquetas[tipo][grupo], id, nombre)
      if (!this.estructura[tipo]) this.$set(this.estructura, tipo, blankEstructura())
      if (grupo === 'salas') {
        const extra = (this.estructura[tipo].salasExtra || []).find(x => String(x.id) === String(id))
        if (extra) this.$set(extra, 'nombre', nombre)
      }
      if (grupo === 'items') {
        const extra = (this.estructura[tipo].itemsExtra || []).find(x => String(x.id) === String(id))
        if (extra) this.$set(extra, 'nombre', nombre)
      }
    },
    onAgregarSala(tipo) {
      if (!this.edicionLibre) return
      if (!this.estructura[tipo]) this.$set(this.estructura, tipo, blankEstructura())
      const id = nuevoIdCampo('sala')
      if (!this.estructura[tipo].salasExtra) this.$set(this.estructura[tipo], 'salasExtra', [])
      this.estructura[tipo].salasExtra.push({ id, nombre: 'NUEVA SALA' })
      if (!this.etiquetas[tipo]) this.$set(this.etiquetas, tipo, blankEtiquetas())
      this.$set(this.etiquetas[tipo].salas, id, 'NUEVA SALA')
      this.asegurarFilaValores(tipo, id)
      this.$set(this.estructura, tipo, normalizarEstructura(this.estructura[tipo]))
    },
    onEliminarSala(tipo, { id }) {
      if (!this.edicionLibre || id == null) return
      if (!this.estructura[tipo]) this.$set(this.estructura, tipo, blankEstructura())
      const sid = String(id)
      const extras = this.estructura[tipo].salasExtra || []
      const idx = extras.findIndex(x => String(x.id) === sid)
      if (idx >= 0) {
        extras.splice(idx, 1)
      } else if (!(this.estructura[tipo].salasEliminadas || []).includes(sid)) {
        if (!this.estructura[tipo].salasEliminadas) {
          this.$set(this.estructura[tipo], 'salasEliminadas', [])
        }
        this.estructura[tipo].salasEliminadas.push(sid)
      }
      if (this.etiquetas[tipo] && this.etiquetas[tipo].salas) {
        this.$delete(this.etiquetas[tipo].salas, sid)
      }
      if (this.valores[tipo] && this.valores[tipo][sid]) {
        this.$delete(this.valores[tipo], sid)
      }
      this.$set(this.estructura, tipo, normalizarEstructura(this.estructura[tipo]))
    },
    onAgregarItem(tipo, { categoriaId } = {}) {
      if (!this.edicionLibre) return
      if (!this.estructura[tipo]) this.$set(this.estructura, tipo, blankEstructura())
      const id = nuevoIdCampo('item')
      const cats = (this.configVista(tipo).categorias || [])
      const catId = categoriaId || (cats.length ? cats[cats.length - 1].id : '')
      if (!this.estructura[tipo].itemsExtra) this.$set(this.estructura[tipo], 'itemsExtra', [])
      this.estructura[tipo].itemsExtra.push({
        id,
        nombre: 'NUEVO CAMPO',
        categoriaId: catId ? String(catId) : '',
      })
      if (!this.etiquetas[tipo]) this.$set(this.etiquetas, tipo, blankEtiquetas())
      this.$set(this.etiquetas[tipo].items, id, 'NUEVO CAMPO')
      this.asegurarFilaValores(tipo, id)
      this.$set(this.estructura, tipo, normalizarEstructura(this.estructura[tipo]))
    },
    onEliminarItem(tipo, { id }) {
      if (!this.edicionLibre || id == null) return
      if (!this.estructura[tipo]) this.$set(this.estructura, tipo, blankEstructura())
      const sid = String(id)
      const extras = this.estructura[tipo].itemsExtra || []
      const idx = extras.findIndex(x => String(x.id) === sid)
      if (idx >= 0) {
        extras.splice(idx, 1)
      } else if (!(this.estructura[tipo].itemsEliminados || []).includes(sid)) {
        if (!this.estructura[tipo].itemsEliminados) {
          this.$set(this.estructura[tipo], 'itemsEliminados', [])
        }
        this.estructura[tipo].itemsEliminados.push(sid)
      }
      if (this.etiquetas[tipo] && this.etiquetas[tipo].items) {
        this.$delete(this.etiquetas[tipo].items, sid)
      }
      if (this.valores[tipo] && this.valores[tipo][sid]) {
        this.$delete(this.valores[tipo], sid)
      }
      this.$set(this.estructura, tipo, normalizarEstructura(this.estructura[tipo]))
    },
    restablecer() {
      Swal.fire({
        icon: 'question',
        title: '¿Restablecer?',
        text: 'Se limpiarán los valores no guardados de esta vista.',
        showCancelButton: true,
        confirmButtonText: 'Sí, limpiar',
        cancelButtonText: 'Cancelar',
      }).then((r) => {
        if (r.isConfirmed) {
          this.initValores()
          this.cargar()
        }
      })
    },
    async guardarTipo(tipo) {
      const payload = {
        tipo,
        anio: this.anio,
        mes: this.mes,
        sala: '',
        valores: this.valores[tipo] || {},
        responsables: {
          etiquetas: this.etiquetas[tipo] || blankEtiquetas(),
          estructura: normalizarEstructura(this.estructura[tipo] || blankEstructura()),
        },
        total: this.totalGeneral(tipo),
        usuario_id: sessionStorage.getItem('idUsuario'),
        usuario_nombre: sessionStorage.getItem('nombre') || sessionStorage.getItem('usuario') || '',
      }
      const res = await apiPostAutenticado('/pe_kardex/guardar/', payload)
      if (res && res.id) this.$set(this.registroIds, tipo, res.id)
    },
    async guardar() {
      this.guardando = true
      try {
        await Promise.all(TIPOS.map(tipo => this.guardarTipo(tipo)))
        Swal.fire({
          icon: 'success',
          title: 'Guardado',
          text: 'Los registros se guardaron correctamente.',
          timer: 1600,
          showConfirmButton: false,
        })
      } catch (e) {
        console.error(e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: (e && e.response && e.response.data && e.response.data.detail)
            || 'No se pudo guardar el registro.',
        })
      } finally {
        this.guardando = false
      }
    },
  },
}
</script>

<style scoped>
.pe-page {
  --navy: #0b3d78;
  --line: #e4e8ee;
  --muted: #64748b;
}

.pe-vista-bar {
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 12px;
}

.pe-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 120px;
}

.pe-field label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #7b8794;
  text-transform: uppercase;
}

.pe-field input {
  height: 40px;
  border: 1px solid #d7dee7;
  border-radius: 8px;
  padding: 0 0.75rem;
  font-size: 0.9rem;
  color: #1e293b;
  background: #fff;
  outline: none;
}

.pe-field input:focus {
  border-color: #93c5fd;
  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.35);
}

.pe-vista-meta {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  text-align: right;
  min-width: 160px;
}

.pe-vista-meta strong {
  font-size: 0.82rem;
  color: #0f172a;
  max-width: 320px;
  line-height: 1.25;
}

.pe-vista-meta span {
  font-size: 0.78rem;
  color: var(--muted);
}

.pe-header__actions {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.pe-icon-btn,
.pe-btn {
  border: 1px solid #d7dee7;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  font-size: 0.88rem;
  font-weight: 600;
  color: #334155;
}

.pe-icon-btn {
  width: 40px;
  height: 40px;
}

.pe-btn {
  height: 40px;
  padding: 0 0.95rem;
}

.pe-btn--primary {
  background: var(--navy);
  border-color: var(--navy);
  color: #fff;
}

.pe-btn--primary:disabled,
.pe-icon-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.kx-legend {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.78rem;
  color: #667085;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.kx-legend span {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.pe-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.pe-dot--yellow { background: #eab308; }
.pe-dot--blue { background: #2563eb; }
.pe-dot--gray { background: #cbd5e1; }

@media (max-width: 960px) {
  .pe-vista-meta {
    margin-left: 0;
    text-align: left;
    width: 100%;
  }
}
</style>
